// extracted by mini-css-extract-plugin
export default {"drawerContainer":"drawerContainer___Z3Yqc","drawerHeader":"drawerHeader___ZRuVA","drawerBody":"drawerBody___nU4bK","closeIcon":"closeIcon____1jyS"};